import {AfterContentInit, Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[mc-autofocus]',
})
export class AutofocusDirective implements AfterContentInit {
  constructor(private host: ElementRef) {}

  ngAfterContentInit() {
    this.host.nativeElement.focus();
  }
}
